module.exports = __webpack_public_path__ + "img/zhanghaoguanli.ac85ca58.png";